import { Icon } from "@circle-react-shared/Icon";
import { Switch } from "@circle-react-uikit/Switch";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import noop from "lodash/noop";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { ToggleSwitch } from "./ToggleSwitch";

export interface ToggleSwitchWithLabelProps {
  className?: string;
  disabled?: boolean;
  field: string;
  label?: string;
  labelClassName?: string;
  onChange?: (value: unknown) => void;
  toggleSwitchClassName?: string;
  toggleSwitchLabelClassName?: string;
  tooltipText?: string | ReactNode;
  value?: boolean;
  variant?: "default" | "large" | "small";
}

export const ToggleSwitchWithLabel = ({
  label = t("toggle_switch"),
  field,
  value = false,
  onChange = noop,
  tooltipText,
  className,
  labelClassName,
  toggleSwitchClassName,
  toggleSwitchLabelClassName,
  variant = "default",
  disabled = false,
}: ToggleSwitchWithLabelProps) => (
  <div
    className={classNames(
      "flex flex-row items-center justify-between",
      className,
    )}
  >
    {!tooltipText ? (
      <span className={classNames("text-default", labelClassName)}>
        {label}
      </span>
    ) : (
      <span className="text-default flex items-center">
        {label}
        <TippyV2 content={tooltipText}>
          <span className="inline-flex">
            <Icon type="question-mark" className="ml-2 !w-3" />
          </span>
        </TippyV2>
      </span>
    )}
    <div id={`field-${field}`} className="flex items-center">
      {variant === "small" ? (
        <>
          <input
            type="checkbox"
            name={field}
            id={`checkbox-${field}`}
            checked={value}
            onChange={onChange}
            disabled={disabled}
            className="peer hidden"
          />
          <label
            className={classNames("m-0", {
              "cursor-not-allowed opacity-10": disabled,
            })}
            htmlFor={`checkbox-${field}`}
          >
            <Switch as="span" checked={value} onChange={onChange} />
            <span className="sr-only">{label}</span>
          </label>
        </>
      ) : (
        <ToggleSwitch
          field={field}
          value={value}
          onChange={onChange}
          variant={variant}
          disabled={disabled}
          wrapperClassName={toggleSwitchClassName}
          labelClassName={toggleSwitchLabelClassName}
        />
      )}
    </div>
  </div>
);
